import {
  createExternalBookingAPIKey,
  deleteExternalBookingAPIKey,
  updateExternalBookingAPIKey,
} from '@store/ExternalBookingAPIKeyReducer'
import { useAppDispatch, useAppSelector } from '@store/hooks'
import { SBRM, SBRMForm } from '@supplement-bacon/sbrm-react'
import { forwardRef } from 'react'
import Create from './Create'
import Delete from './Delete'
import Update from './Update'

export const ExternalBookingAPIKeyForm: SBRMForm = forwardRef(
  ({ formProps }, ref) => {
    const dispatch = useAppDispatch()
    const { error } = useAppSelector((state) => state.externalBookingAPIKey)

    return (
      <SBRM.BaseEntityForm
        {...{ ref, formProps }}
        error={error && String(error)}
        formActions={{
          create: Create,
          update: Update,
          delete: Delete,
        }}
        handlers={{
          create: async (values) =>
            dispatch(createExternalBookingAPIKey(values)).then(() => {
              return true
            }),
          update: async (values) =>
            dispatch(updateExternalBookingAPIKey(values)).then(() => {
              return true
            }),
          delete: async (values) =>
            dispatch(deleteExternalBookingAPIKey(values)).then(() => {
              return true
            }),
        }}
      />
    )
  }
)

ExternalBookingAPIKeyForm.displayName = 'ExternalBookingAPIKeyForm'

export default ExternalBookingAPIKeyForm
